/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const bootstrapReadMoreBtn = () => {
    let button = document.querySelector('.read-more__button-container');
    console.log(button);
    if (button == null || typeof button == 'undefined') {
        window.setTimeout(() => {
            bootstrapReadMoreBtn();
            return;
        }, 1000);
    }
    if(button != null && typeof button != 'undefined') {
        button.addEventListener('click', () => {
            let expanded = button.getAttribute('data-expanded');
            button.style.display = 'none';
            document.querySelector('.read-more__text.closed').style.maxHeight = '99999px';
            document.querySelector('.read-more__text.closed').classList.add('expanded');
        });
    }
};

bootstrapReadMoreBtn();

/*
const bootstrapPriceOverloadForMerchantFeed = () => {
    //First of all try to indentify if we're on a product page.
    let pageCheck = document.querySelector('.product-form__info-list');
    if(typeof pageCheck == 'undefined' || pageCheck == null) {
        window.setTimeout(() => {
            console.log("||", 'Reloading exemptify fixer');
            bootstrapPriceOverloadForMerchantFeed();
            return;
        }, 1000);
    }

    //Get the price value
    let priceContainer = document.querySelector('.price-list .price');
    console.log("|||", priceContainer);
    //priceContainer.innerHTML = '14.39';
};

bootstrapPriceOverloadForMerchantFeed();
*/
